import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const moveFulfillmentGroupToTote = {
  name: "moveFulfillmentGroupToTote" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    toToteId: zExt.objectId().nullish(), // Optional - if not provided, removes from current tote
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string().nullish(),
    fromToteId: z.string().nullish(),
    toToteId: z.string().nullish(),
  }),
};
